import React from 'react'

import { SweetspotMark } from '@/components/common/SweetspotMark'

interface SweetspotMarkAnimatedProps {
  size?: number
  className?: string
}

/**
 * The busy mark, drawn from the frame the pulse opens on.
 *
 * The pulse is a 5,950ms loop written inside the SVG, so the browser runs it on
 * the image resource rather than on any one element, and mounting a fresh `<img>`
 * for that file restarts the loop — for every copy of it on the page at once. A
 * streaming run hands the mark between the text part, the tool rows and the
 * compaction row a dozen or more times, each handoff a fresh `<img>`, so the loop
 * is restarted throughout and rarely plays past its opening second.
 *
 * That opening second is the whole difference between the two variants. The
 * clear-start file opens on an empty frame and draws the mark in, so every
 * handoff blinks the mark out; the mark-start file opens on the mark itself and
 * dips from there, so a handoff at worst repeats a dip, which reads as the pulse
 * carrying on.
 */
export const SweetspotMarkAnimated: React.FC<SweetspotMarkAnimatedProps> = ({
  size = 16,
  className,
}) => (
  <SweetspotMark variant="pulse-markstart" size={size} className={className} />
)

export default SweetspotMarkAnimated
